import { each, isNil, isObject, set, isString, isNaN } from 'lodash-es';
import debug from 'debug';
import { AxiosResponse } from 'axios';
import qs from 'qs';

const log = debug('itp:core:connections:helpers');

export function asFormData(data: Dictionary<any>): FormData {
  if (data instanceof FormData) {
    return data;
  }

  const result = new FormData();

  each(data, (v, k) => {
    if (!isNil(v) && !isNaN(v)) {
      result.set(k, v);
    }
  });

  return result;
}

export function formatPayload(payload: any, contentType: string) {
  if (payload && contentType.indexOf('x-www-form-urlencoded') > -1) {
    log('formatting payload with qs (x-www-form-urlencoded) %o', payload);
    return qs.stringify(payload);
  }

  if (payload && contentType.indexOf('form-data') > -1) {
    log('mapping payload to FormData (form-data)');
    return asFormData(payload);
  }

  return payload;
}

export function enhanceResponseWithEtag(response: AxiosResponse) {
  const etag = response.headers['etag'];

  if (etag && isObject(response.data)) {
    set(response.data, '$etag', etag);
    set(response.data, 'etag', etag);
  }

  return response;
}

export const isOpenapiPath = (path: string) =>
  path && path.startsWith('$openapis/');

export const getOpenapiPath = (path: string) =>
  isOpenapiPath(path) ? path.substring('$openapis/'.length) : null;

export const isDataPath = (path: string) =>
  isString(path) && path.startsWith('$data.');

export function getDataPath(path: any): string | null {
  return isDataPath(path) ? path.split('.').slice(1).join('.') : null;
}
